import { AllocationData } from '../types/tokenomics';

export const tokenAllocations: AllocationData[] = [
  {
    title: "Real Estate Acquisition Fund",
    percentage: "40%",
    tokens: "40,000,000",
    scheduleTitle: "Vesting Schedule",
    schedule: [
      "Initial Unlock: 10M tokens (25%) at launch",
      "Remaining 30M tokens: Linear monthly unlock of 1.25M tokens over 24 months"
    ],
    note: "Purpose: Dedicated to property acquisitions and portfolio growth"
  },
  {
    title: "Liquidity",
    percentage: "30%",
    tokens: "30,000,000",
    scheduleTitle: "Release Schedule",
    schedule: [
      "Initial Launch: 5M tokens (16.67%)",
      "3.125M tokens release every quarterly"
    ],
    note: "All liquidity is paired with SOL"
  },
  {
    title: "Marketing & Partnerships",
    percentage: "15%",
    tokens: "15,000,000",
    scheduleTitle: "Vesting Schedule",
    schedule: [
      "Initial Unlock: 25% (3.75M tokens) at launch",
      "Remaining 11.25M tokens: Quarterly release of 1.41M tokens over 24 months"
    ]
  },
  {
    title: "Team & Development",
    percentage: "10%",
    tokens: "10,000,000",
    scheduleTitle: "Vesting Schedule",
    schedule: [
      "Initial Unlock: 20% (2M tokens) at launch",
      "Remaining 8M tokens: Quarterly release of 1M tokens over 24 months"
    ]
  },
  {
    title: "DAO Treasury",
    percentage: "5%",
    tokens: "5,000,000",
    scheduleTitle: "Vesting Schedule",
    schedule: [
      "Initial Lock: 6 months",
      "20% unlock after 6 months",
      "Remaining 80% controlled by DAO voting after 12 months"
    ]
  }
];